import { Locale, type LocalizedString } from "@core/schema/Locale.js";

export const applicationFormId: LocalizedString = {
	[Locale.cs]: "prihlaska",
	[Locale.en]: "application",
};
